import { codes } from '../../../../data/translations';
import errorCodes from '../../../../data/translations/errorCodes';

export default {
	wrongLogIn: codes.user.wrongLogIn,
	loginCooldown: codes.user.loginCooldown,
	sessionExpired: codes.user.sessionExpired,
	wrongPinCode: codes.user.wrongPinCode,
	wrongAuthCode: codes.user.wrongAuthCode,
	default: errorCodes.internalError,
	documentEndDate: codes.user.wrongIdDocumentExpirationDate,
	documentNumber: codes.user.wrongIdDocumentNumber,
	passwordSymbolsValidation: codes.user.passwordSymbolsValidation,
	passwordAlphabeticCharacterValidation: codes.user.atLeast1AlphabeticCharacter,
	passwordNumericValidation: codes.user.atLeast1NumericCharacter,
	passwordSpecialCharacterValidation: codes.user.atLeast1SpecialCharacter,
	passwordNotUnique: codes.user.passwordNotUniqueDescription,
	blockedUserLogin: codes.user.thisAccountIsBlockedOrInactive,
	wrongLogInUseADFS: codes.user.wrongLoginUseAdfs,
	wrongLogInUseAzureAd: errorCodes.wrongLogInUseAzureAd,
	blockedUserByAccessRequest: errorCodes.noEnvironmentAccess,
	wrongCurrentPassword: errorCodes.wrongCurrentPassword,
	wrongNewPasswordConfirm: errorCodes.wrongNewPasswordConfirm,
	required: errorCodes.required,
	maxLength: errorCodes.maxLength,
	cannotChangePasswordUseADFS: errorCodes.cannotChangePasswordUseADFS,
	cannotChangePasswordUseAzureAd: errorCodes.cannotChangePasswordUseAzureAd,
	weakPassword: errorCodes.weakPassword,
};
